import { atom } from 'jotai';

export const recaptchaTokenAtom = atom<string>(undefined as string);

export const progressBarValueAtom = atom<number>(0);
